// extracted by mini-css-extract-plugin
module.exports = {"root":"ActorLabel_root__AZlo5","truncateText":"ActorLabel_truncateText__m0XeS"};